import  Rearchhero from "./Rearchhero"
import ResearchProjects from "./ResearchProjects"
import Technology from "./Technology"

export const Researchmain = () => {
  return (
    <>
       <Rearchhero />
       <ResearchProjects />
       <Technology />
    </>
  )
}
